<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>


<style>
html,
body,
#app {
  height: 100%;
  background: #E8E8E8 !important;
}
</style>
